import type { MenuSearchResponse } from '@library/api-menu-experience'

export type MenuExperienceSearchViewState =
  | { status: 'idle' }
  | { status: 'loading'; query: string }
  | { status: 'error'; error: unknown }
  | { status: 'ready'; response: MenuSearchResponse }
  | { status: 'replacing'; response: MenuSearchResponse }

type GetMenuExperienceSearchViewStateInput = {
  error?: unknown
  isLoading: boolean
  isReplacing: boolean
  query: string
  response?: MenuSearchResponse
}

export const getMenuExperienceSearchViewState = ({
  error,
  isLoading,
  isReplacing,
  query,
  response,
}: GetMenuExperienceSearchViewStateInput): MenuExperienceSearchViewState => {
  if (error) return { status: 'error', error }

  if (response) {
    return isReplacing ? { status: 'replacing', response } : { status: 'ready', response }
  }

  if (isLoading) return { status: 'loading', query }

  return { status: 'idle' }
}

export const isMenuExperienceSearchBusy = (viewState: MenuExperienceSearchViewState): boolean =>
  viewState.status === 'loading' || viewState.status === 'replacing'

export const isMenuExperienceSearchReplacing = (
  viewState: MenuExperienceSearchViewState,
): boolean => viewState.status === 'replacing'
